import React from 'react'
import UserForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import Service from './edit.service'
import Checkbox from '../../../../components/inputs/checkbox/checkbox.component'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

class UserEdit extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadRoles()
        this.service.loadUser()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.service.isValid() && this.service.save()
    }

    onChangeRole = (roleId, checked) => this.service.onChangeUserRole(roleId)

    onCancel = () => {
        this.props.history.push('/security/users')
    }

    render() {
        return (
            <div className="create">
                <div className="header">
                        <h4>Edit User</h4>
                    </div>
                <div className="card">
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <UserForm {...this.state} onChange={FormHelper(this, "user").onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}>
                        <h4>Roles</h4>
                        <div className="row-roles">
                            {
                                this.state.roles.map((role, key) => <Checkbox key={key} text={role.name} name={role.id} checked={this.service.containsUserRole(role.id)} onChange={this.onChangeRole} />)
                            }
                        </div>
                    </UserForm>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(UserEdit))